import React, { useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X } from 'lucide-react';
interface LegalModalProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  children: React.ReactNode;
}
export function LegalModal({
  isOpen,
  onClose,
  title,
  children
}: LegalModalProps) {
  useEffect(() => {
    const handleKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose();
    };
    if (isOpen) {
      document.addEventListener('keydown', handleKey);
      document.body.style.overflow = 'hidden';
    }
    return () => {
      document.removeEventListener('keydown', handleKey);
      document.body.style.overflow = '';
    };
  }, [isOpen, onClose]);
  return <AnimatePresence data-id="element-85">
      {isOpen && <motion.div initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} exit={{
      opacity: 0
    }} transition={{
      duration: 0.2
    }} className="fixed inset-0 z-50 flex items-center justify-center p-4" aria-modal="true" role="dialog" aria-labelledby="legal-modal-title" data-id="element-86">
          <div className="absolute inset-0 bg-brand-text/60 backdrop-blur-sm" onClick={onClose} data-id="element-87" />
          <motion.div initial={{
        opacity: 0,
        scale: 0.95,
        y: 10
      }} animate={{
        opacity: 1,
        scale: 1,
        y: 0
      }} exit={{
        opacity: 0,
        scale: 0.95,
        y: 10
      }} transition={{
        duration: 0.2
      }} className="relative z-10 w-full max-w-2xl max-h-[85vh] flex flex-col bg-brand-cream rounded-3xl shadow-2xl overflow-hidden" data-id="element-88">
            <div className="flex items-center justify-between px-6 py-5 border-b border-brand-accent/50 flex-shrink-0" data-id="element-89">
              <h2 id="legal-modal-title" className="text-2xl font-bold text-brand-text" data-id="element-90">
                {title}
              </h2>
              <button onClick={onClose} aria-label="Cerrar" className="p-2 rounded-full text-brand-text/60 hover:bg-brand-accent/40 hover:text-brand-text transition-colors" data-id="element-91">
                <X className="w-5 h-5" data-id="element-92" />
              </button>
            </div>
            <div className="px-6 py-6 overflow-y-auto text-brand-text/80 leading-relaxed space-y-4 text-sm md:text-base" data-id="element-93">
              {children}
            </div>
          </motion.div>
        </motion.div>}
    </AnimatePresence>;
}